import { withCompInfo } from '@wix/editor-elements-integrations'
import type {
	BuilderDefinition,
	BuilderProps,
	BuilderSdkData,
	CreateBuilderPropsParams,
	CreateBuilderSdkDataParams,
} from './Builder'
import type { ElementData, IManifestPublicElement } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { extractComponentData } from '@wix/thunderbolt-commons'

const extractContainersInfoFromManifest = (reducedManifest: IManifestPublicElement['reducedComponentModel']) => {
	const elementToContainersData = _.reduce(
		reducedManifest?.elementData || {},
		(acc: Record<string, NonNullable<ElementData['containersData']>>, data, key) => {
			if (data?.containersData && !_.isEmpty(data.containersData)) {
				acc[key] = data.containersData
			}
			return acc
		},
		{} as Record<string, NonNullable<ElementData['containersData']>>
	)

	const templateContainers = _.pickBy(
		_.mapValues(elementToContainersData, (elementContainers) =>
			_.pickBy(elementContainers, ({ containerType }) => containerType === 'template')),
		(elementContainers) => !_.isEmpty(elementContainers)
	)

	return { elementToContainersData, templateContainers }
}

export const createBuilderProps = ({
	innerElementsProps,
	compData,
	structure,
	reducedManifest,
}: CreateBuilderPropsParams): BuilderProps => {
	const { elementsRemovalState, elementProps } = innerElementsProps
	const { elementToContainersData, templateContainers } = extractContainersInfoFromManifest(reducedManifest)

	return {
		elementProps,
		_wrapperProps: {
			componentId: structure?.id,
		},
		wix: {
			elementsRemovalState,
			wixPath: structure?.id,
		},
		elementToContainersData,
		templateContainers,
		...extractComponentData(compData),
	}
}

const createBuilderSdkData = ({ reducedManifest, compDescendants }: CreateBuilderSdkDataParams): BuilderSdkData => {
	const { templateContainers } = extractContainersInfoFromManifest(reducedManifest)

	return Object.keys(templateContainers).length > 0 ? { templateContainersChildComponents: compDescendants } : {}
}

export const props = withCompInfo<BuilderProps, BuilderDefinition>()(
	// @ts-ignore
	['innerElementsProps', 'compData', 'structure', 'reducedManifest'],
	createBuilderProps
)

export const sdkData = withCompInfo<BuilderSdkData, BuilderDefinition>()(
	// @ts-ignore
	['reducedManifest', 'compDescendants'],
	createBuilderSdkData
)
